module.exports = __webpack_public_path__ + "img/usutabi.52f26170.jpg";